import React from 'react';
import { css } from 'emotion';
import { CircularProgress } from '@branchjs/neo-components';

const NEOCircularProgress = () => {
  const loadingStyles = css({
    position: 'relative',
    inset: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 40,
  });
  return <CircularProgress className={loadingStyles} />;
};

export default NEOCircularProgress;
